import React from 'react'
import Lottie from 'react-lottie'

// import json1 from '../srcJson/Map.json'
// import json2 from '../srcJson/Map_effect.json'

import atom from '../srcJson/Atom.json'

import './AtomAnimation.module.scss'

class AtomAnimation extends React.Component {
  static defaultProps = {
    height: 161,
    width: 161
  }

  render () {
    const { width, height } = this.props
    const atomEffect = {
      loop: true,
      autoplay: true,
      animationData: atom,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    }

    return (
      <div className='atom-animation' style={{ height }}>
        <Lottie
          options={atomEffect}
          height={height}
          width={width}
        />
      </div>
    )
  }
}

export default AtomAnimation
